import _isNil from "lodash/isNil";

export default function mergeCommonErrors(
  errors: { [key: string]: string | string[] },
  ignoreKeys: string[] = [],
): { [key: string]: string | string[] | Record<string, string | string[]> } {
  const finalErrors: { [key: string]: string | string[] | Record<string, string | string[]> } = {}
  const commonErrors = [];
  for (let key in errors) {
    const value = errors[key];
    if (_isNil(value)) continue;
    const keyParts = key.split('.');
    const mainKey = keyParts.shift();
    if (ignoreKeys.includes(mainKey)) {
      if (keyParts.length > 0) {
        const subKey = keyParts.join('.');
        if (!finalErrors[mainKey]) finalErrors[mainKey] = {};
        (finalErrors[mainKey] as Record<string, string | string[]>)[subKey] = value;
      } else {
        finalErrors[mainKey] = value;
      }
    } else {
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          commonErrors.push(value[i]);
        }
      } else {
        commonErrors.push(value);
      }
    }
  }
  if (commonErrors.length) finalErrors.common = commonErrors;
  return finalErrors;
}

export const getCommonError = (errors: { [key: string]: string | string[] }) => {
  const { common } = mergeCommonErrors(errors);
  return common ? common.toString() : '';
}
